import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-body1 text-weight-bold text-negative q-mb-sm" }, " Delete Account ", -1)
const _hoisted_2 = { class: "text-body1" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("strong", null, "permanently deleted", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_delete_account_btn = _resolveComponent("delete-account-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("p", _hoisted_2, [
      _createTextVNode(" All posts related to this account will be "),
      _hoisted_3,
      _createTextVNode(" from Private Footprint. This has no impact on the client's actual " + _toDisplayString(_ctx.platform.name) + " account. ", 1)
    ]),
    _createVNode(_component_delete_account_btn, { "social-account": _ctx.account }, null, 8, ["social-account"])
  ]))
}